import {Pipe, PipeTransform} from '@angular/core';
import {MaterialOrderCreateOrderListElemForm} from '../../material-order.model';

@Pipe({
    name: 'ArticleFilters',
    standalone: false
})
export class ArticleFilters implements PipeTransform {
  transform(orders: MaterialOrderCreateOrderListElemForm[], id: number): MaterialOrderCreateOrderListElemForm[] {
    return orders.filter(a => a.variation_id === id);
  }
}
